var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"content-wrap"},[(_vm.sessionWarning)?_c('session-expiring'):_vm._e(),_c(_vm.layout,{tag:"component"})],1),_c('es-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }